import { Inject, Injectable } from '@angular/core';
import { MmbHttpUtilsService } from '@src/components/services/Utils/ib-Mmb-http-utils.service';
import { MmBAppConstants } from '@src/ib-MmB-constants';
import { CommonsSessionStorageService } from 'ib-web-commons/utils';
import { AJSCommonsGenericProxyService, AJSCommonsGenericProxyServiceType } from '../../../../services/http/commons-proxy-bridge.service';

@Injectable()
export class IbMmbPaymentComponentService {
    constructor (
        private CommonsSessionStorageService: CommonsSessionStorageService,
        private MmbHttpUtilsService: MmbHttpUtilsService,
        @Inject(AJSCommonsGenericProxyService) private CommonsGenericProxyService: AJSCommonsGenericProxyServiceType
    ){}

    public getPaymentContextId = async () : Promise<any> => {
        await this.MmbHttpUtilsService.refreshToken();
        const flowId: string = this.CommonsSessionStorageService.get('flowId');
        const context = await this.CommonsGenericProxyService.postGeneric(MmBAppConstants.DEFAULT_ENDPOINTS.getPaymentContextURI.replace('{{flowId}}', flowId), {
            'redirection': {
                'success': {
                    'url': 'string',
                    'data': 'string',
                    'method': 'string'
                },
                'failure': {
                    'url': 'string',
                    'data': 'string',
                    'method': 'string'
                }
            }
        });
        return context.data.contextId;
        //return '9574d55c-b08f-4b96-a27c-8cd2aa838cb4';

    };
}

// https://services.{environment}.ancillaries.cloud.iberia.com/v1/payment/payment-context/{flowId}
// https://api.int.ancillaries.cloud.iberia.com/api/v1/payment/payment-context/TWFuYWdlTXlCb29raW5nQElCYTIyZGJkZGU0MTVmNDdjMGFiMmFlMDQ1ZDZkYmE5NTU=
